(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-atc-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-atc-hero .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-atc-perks"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-atc-perks .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-atc"] && !Shopify.designMode) return;
  try {
    
class DropAtcForm extends HTMLElement {
  connectedCallback() {
    var form = this.querySelector('[data-email-form]');
    if (form) this._setup(form);
  }
  _setup(form) {
    var host = this;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = form.querySelector('[type="email"]');
      var btn   = form.querySelector('button[type="submit"]');
      if (!input || !input.value.trim()) return;

      var email   = input.value.trim();
      var pubKey  = host.dataset.klaviyoKey;
      var listId  = host.dataset.klaviyoList;

      if (btn) { btn.textContent = '…'; btn.disabled = true; }

      function showSuccess() {
        var p = document.createElement('p');
        p.style.cssText = 'font-family:var(--drop-font-body);font-size:15px;font-weight:600;color:var(--drop-peach);margin:0;padding:16px 0;';
        p.textContent = "Welcome to the Club";
        form.replaceWith(p);
      }

      function showError(msg) {
        if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; }
        var existing = form.querySelector('.drop-atc-form-error');
        if (existing) existing.remove();
        var err = document.createElement('p');
        err.className = 'drop-atc-form-error';
        err.style.cssText = 'font-family:var(--drop-font-body);font-size:12px;color:#ff6b6b;margin:8px 0 0;';
        err.textContent = msg || 'Something went wrong — please try again.';
        form.appendChild(err);
      }

      if (btn) btn.dataset.label = btn.textContent;

      if (!pubKey || !listId) {
        showError('Email signup is not configured yet.');
        return;
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pubKey), {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function(res) {
        if (res.ok || res.status === 202) {
          showSuccess();
        } else {
          showError('Something went wrong — please try again.');
        }
      }).catch(function() {
        showError('Could not connect — please try again.');
      });
    });
  }
}
if (!customElements.get('drop-atc-form')) customElements.define('drop-atc-form', DropAtcForm);

(function() {
  var els = document.querySelectorAll('.drop-atc-tease .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-collection-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-coll-hero .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-faq"] && !Shopify.designMode) return;
  try {
    
// Accordion logic
document.querySelectorAll('.drop-faq__question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var answer   = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      answer.setAttribute('hidden', '');
    } else {
      answer.removeAttribute('hidden');
    }
  });
});

// Reveal on scroll
(function() {
  var els = document.querySelectorAll('.drop-faq .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-hero"] && !Shopify.designMode) return;
  try {
    
class DropHero extends HTMLElement {
  connectedCallback() {
    this._phase = this.dataset.phase;
    this._orderingCloses = new Date(this.dataset.orderingCloses);
    this._preorderOpens = new Date(this.dataset.preorderOpens);

    if (this._phase === 'live') {
      this._startCountdown(this._orderingCloses, '[data-countdown="live"]');
    } else if (this._phase === 'preorder') {
      this._startCountdown(this._preorderOpens, '[data-countdown="preorder"]');
    }

    const form = this.querySelector('[data-email-form]');
    if (form) this._setupForm(form);
  }

  _startCountdown(target, selector) {
    const wrap = this.querySelector(selector);
    if (!wrap) return;
    const days = wrap.querySelector('[data-days]');
    const hrs  = wrap.querySelector('[data-hours]');
    const min  = wrap.querySelector('[data-minutes]');
    const sec  = wrap.querySelector('[data-seconds]');
    const pad  = n => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { [days, hrs, min, sec].forEach(el => el && (el.textContent = '00')); return; }
      if (days) days.textContent = pad(Math.floor(diff / 86400000));
      if (hrs)  hrs.textContent  = pad(Math.floor((diff % 86400000) / 3600000));
      if (min)  min.textContent  = pad(Math.floor((diff % 3600000) / 60000));
      if (sec)  sec.textContent  = pad(Math.floor((diff % 60000) / 1000));
    };
    tick();
    this._timer = setInterval(tick, 1000);
  }

  _setupForm(form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const input = form.querySelector('[type="email"]');
      const btn   = form.querySelector('button[type="submit"]');
      if (!input || !input.value.trim()) return;
      if (btn) { btn.textContent = '…'; btn.disabled = true; }
      const success = document.createElement('p');
      success.style.cssText = 'font-family:var(--drop-font-body);font-size:15px;font-weight:600;color:var(--drop-mint-deep);margin:0;padding:16px 0;';
      success.textContent = "You're on the list!";
      form.replaceWith(success);
    });
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }
}
if (!customElements.get('drop-hero')) customElements.define('drop-hero', DropHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-shop-flavours"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.drop-shop-flav__qty').forEach(function(wrap) {
    var input = wrap.querySelector('.drop-shop-flav__qty-input');
    wrap.querySelectorAll('.drop-shop-flav__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'increase') {
          input.value = val + 1;
        } else if (btn.dataset.action === 'decrease') {
          input.value = Math.max(1, val - 1);
        }
      });
    });
  });

  // Variant switching — update price when a pill is selected
  document.querySelectorAll('.drop-shop-flav__card').forEach(function(card) {
    var radios = card.querySelectorAll('.drop-shop-flav__variants input[type="radio"]');
    if (!radios.length) return;
    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var priceEl = card.querySelector('.drop-shop-flav__price-current');
        var compareEl = card.querySelector('.drop-shop-flav__price-compare');
        if (priceEl) priceEl.textContent = this.dataset.price;
        if (compareEl) {
          if (this.dataset.onSale === 'true') {
            compareEl.textContent = this.dataset.compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        var btn = card.querySelector('.drop-shop-flav__atc');
        if (btn) {
          if (this.dataset.available === 'false') {
            btn.textContent = btn.dataset.preorderLabel || 'Pre-Order Now';
          } else {
            btn.textContent = btn.dataset.defaultLabel;
          }
          btn.disabled = false;
        }
      });
    });
  });

  var els = document.querySelectorAll('.drop-shop-flav .drop-sf-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-shop-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-grid .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-steps"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-steps .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-story-bios"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-story-bios .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-story-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-story-hero .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-story-philosophy"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-story-phil .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-story-tease"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-story-tease .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-story-timeline"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('.drop-story-tl .drop-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
